module.exports = __webpack_public_path__ + "static/JurajBé-44c1a0c04ee042d719415f9de67da29e.jpg";